import React, {useContext, useEffect, useState} from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from '@material-ui/core'
import {ReservationContext} from '../../../../context/Reservation'
import {ReservationConfigurationContext} from '../../../../context/ReservationConfiguration'

export default function WCurrencyField({data, onChange}) {
  const {reservation} = useContext(ReservationContext)
  const [symbol, setSymbol] = useState('')

  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )

  useEffect(() => {
    if (reservation.selected_group?.id) {
      getAdditionalFieldValues(reservation.selected_group?.id, [], false, false, true)
    }
  }, [reservation.selected_group, getAdditionalFieldValues])

  useEffect(() => {
    if (additionalFieldValues.data.data) {
      additionalFieldValues.data.data.currency_items.forEach(label => {
        if (label.id === data.currency_id) {
          setSymbol(label.symbol)
        }
      })
    }
  }, [data.currency_id, additionalFieldValues])

  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel htmlFor="outlined-adornment-amount">{data.name}</InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          value={data.value}
          label={data.name}
          onChange={e => {
            if (e.target.value < 999999999999) {
              onChange(e, 'value', data)
            }
          }}
          type={'number'}
          startAdornment={<InputAdornment position="start">{symbol}</InputAdornment>}
          labelWidth={60}
        />
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}
